import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { PostLoginDepartmentDialogComponent } from '../../../dialog/post-login-department/post-login-department-dialog.component';
// Animation
import { fadeInUpAnimation } from '../../../../@prep/animations/fade-in-up.animation';
import { fadeInRightAnimation } from '../../../../@prep/animations/fade-in-right.animation';
// Browser Fingerprint to generate Unique ID
import Fingerprint from 'fingerprintjs2';
// Services
import { PlatformUserService } from '../service/platform-user.service';
import { PlatformGlobalService } from '../../../layout/service/platform-global.service';
import { AuthRedirectService } from '../../../layout/service/auth-redirect.service';
import { Title } from '@angular/platform-browser';
// Language Selector
import { LanguageSelectorService } from 'src/@prep/shared/language-selector/service/language-selector.service';
import { LanguageSelectorModel } from 'src/@prep/shared/language-selector/model/language-selector.model';
import { LoginTextDataEN } from '../auth-multi-lang/en-US';
import { LoginTextDataES } from '../auth-multi-lang/es-EU';
import { LoginTextDataIT } from '../auth-multi-lang/it-IT';
import { environment } from 'src/environments/environment.prod';
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Component({
  selector: 'prep-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [PlatformUserService, PlatformGlobalService],
  animations: [fadeInUpAnimation, fadeInRightAnimation],
})
export class LoginComponent implements OnInit {
  // User Login
  UserLoginFormGroup: FormGroup;
  // To extract device unique ID
  resultFingerPrint: any;

  is_loading = false; // Loading spinner flag
  inputType = 'password'; // Password input type
  visible = false;

  // SSOFlow flag to check if the flow is SSO or not
  readonly SSOFlow = environment.sso;
  readonly ssoLabel = environment.ssoLabel;
  readonly ssoUrl = environment.ssoUrl;
  isPlamBeach = environment.ssoLabel === 'PALM BEACH COUNTY BOARD COUNTY COMMISSIONERS';


  // Language Selector
  selectedLang: LanguageSelectorModel = this.languageSelectorService.getCurrentLanguage();
  LangTextData: any;
  // Accessibility
  @ViewChild('emailInputRef', { static: false }) emailInputRef!: ElementRef<HTMLInputElement>;
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private snackbar: MatSnackBar,
    private titleService: Title,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private platformuserService: PlatformUserService,
    private platformGlobalService: PlatformGlobalService,
    private languageSelectorService: LanguageSelectorService,
    private liveAnnouncer: LiveAnnouncer,
    private authRedirectService: AuthRedirectService

  ) {

    this.languageSelectorService.language$.subscribe(lang => {
      console.log('🌍 Language changed globally:', lang);
      this.selectedLang = lang;

      switch (this.selectedLang.code) {
        case 'en': {
          this.LangTextData = LoginTextDataEN;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'es': {
          this.LangTextData = LoginTextDataES;
          console.log('🌍 Europe Language:', this.LangTextData);
          break;
        }
        case 'it': {
          this.LangTextData = LoginTextDataIT;
          console.log('🌍 Italian Language:', this.LangTextData);
          break;
        }
        default: {
          this.LangTextData = LoginTextDataEN;
          console.log('🌍 Default Language:', this.LangTextData);
          break;
        }
      }

      // Dynamically replace SSO label from environment config
      if (this.SSOFlow && this.ssoLabel) {
        this.LangTextData.htmlLabel.ssoUserLogin =
          this.LangTextData.htmlLabel.ssoUserLogin.replace('COLORADO SPRINGS', this.ssoLabel);
      }
    });

    if (this.SSOFlow === true) {
      this.UserLoginFormGroup = this.fb.group({
        etaToken: '',
        id: '',
      });
    } else {
      this.UserLoginFormGroup = this.fb.group({
        username: [
          '',
          [
            Validators.required,
            Validators.pattern(
              /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/
            )
          ]
        ],
        password: ['', Validators.required],
        id: '',
      });
    }
    // Generate Fingerprint for Unique ID
    this.resultFingerPrint = async () => {
      const secure = await new Promise((resolve) => {
        Fingerprint.getV18((result, components) => resolve(result));
      });
      return secure;
    };
    this.resultFingerPrint().then((result) => {
      this.resultFingerPrint = result;
      this.UserLoginFormGroup.patchValue({
        id: result,
      });
    });
    console.log('Login Form', this.UserLoginFormGroup.value);
  }

  ngOnInit() {
    this.titleService.setTitle(this.LangTextData.SEOlLabel.appTitle);
    // Check user Offline / Online
    this.platformuserService.createOnline$().subscribe((isOnline) => {
      console.log('online======', isOnline);
      if (!isOnline) {
        this.allInOneSnackBar(
          this.LangTextData.snackbarLabels.errorInternetConnection,
          '',
          10000
        );
      }
    });

    if (this.SSOFlow === true) {
      console.log(
        'router snap shot before condition',
        this.route.snapshot.paramMap.get('etaToken')
      );
      if (this.route.snapshot.paramMap.get('etaToken')) {
        this.UserLoginFormGroup.patchValue({
          etaToken: this.route.snapshot.paramMap.get('etaToken'),
        });
        this.is_loading = true;
        console.log('User Login SSO Mard', this.UserLoginFormGroup.value);
        this.platformuserService.ssoUser(this.UserLoginFormGroup.value).subscribe(
          (response) => {
            console.log('Response SSO USER', response);
            this.is_loading = false;
            localStorage.setItem('token', response['token']);
            this.platformGlobalService.me = response['user'];
            this.checkPostLoginDepartment();
          },
          (error) => {
            console.log('error', error);
            if (error.status === 400) {
              this.is_loading = false;
              this.allInOneSnackBar(this.LangTextData.snackbarLabels.errorLogin400, '', 1500);
              this.router.navigate(['/login']);
            } else if (error.status === 401) {
              this.allInOneSnackBar(
                this.LangTextData.snackbarLabels.errorLogin401,
                '', 1500
              );
              this.router.navigate(['login']);
            } else if (error.status === 417) {
              this.is_loading = false;
              console.log('error info cuncurrent user', error.error.msg);
              if (error.error.msg) {
                this.allInOneSnackBar(error.error.msg, '', 10000);
              }
            } else {
              this.is_loading = false;
              this.router.navigate(['login']);
            }
          }
        );
      } else {
        this.is_loading = false;
      }

    } else {
      // Login User If User already Logged In
      if (localStorage.getItem('token') && localStorage.getItem('account')) {
        this.platformGlobalService.me = JSON.parse(
          localStorage.getItem('account')
        );
        this.checkPostLoginDepartment();
      }
      this.is_loading = false;
    }

  }



  send() {
    if (this.UserLoginFormGroup.invalid || this.is_loading) {
      return;
    }
    this.is_loading = true;
    console.log(this.UserLoginFormGroup.value);
    if (this.SSOFlow === true) {
      const link = document.createElement('a');
      link.setAttribute('href', this.ssoUrl);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      this.platformuserService.loginUser(this.UserLoginFormGroup.value).subscribe(
        (response) => {
          this.is_loading = false;
          localStorage.setItem('token', response['token']);
          this.platformGlobalService.me = response['user'];
          this.announceMessage(this.LangTextData.snackbarLabels.SuccessSignIn);
          this.allInOneSnackBar(this.LangTextData.snackbarLabels.SuccessSignIn, '', 5000);
          this.checkPostLoginDepartment();

        },
        (error) => {
          console.log('error', error);
          if (error.status === 400) {
            this.is_loading = false;
            // Highlight email and password fields with mat-error
            // Set custom flags for username and password errors
            this.UserLoginFormGroup.get('username')?.setErrors({ invalid: true });
            this.UserLoginFormGroup.get('password')?.setErrors({ invalid: true });
            // Clear the errors programmatically by resetting the form
            this.UserLoginFormGroup.reset();
            this.announceMessage(this.LangTextData.snackbarLabels.errorLogin400);
            this.allInOneSnackBar(this.LangTextData.snackbarLabels.errorLogin400, '', 10000);
            this.router.navigate(['/login']);
            this.focusFirstInvalidControl();
          } else if (error.status === 401) {
            this.is_loading = false;
            this.allInOneSnackBar(
              this.LangTextData.snackbarLabels.errorLogin401,
              '', 10000
            );
            this.router.navigate(['login']);
            this.focusFirstInvalidControl();
          } else if (error.status === 417) {
            this.is_loading = false;
            console.log('error info cuncurrent user', error.error.msg);
            if (error.error.msg) {
              this.allInOneSnackBar(error.error.msg, '', 10000);
              this.focusFirstInvalidControl();
            }
          } else {
            this.is_loading = false;
            this.router.navigate(['login']);
            this.focusFirstInvalidControl();
          }
        }
      );
    }
    this.platformuserService.createOnline$().subscribe((isOnline) => {
      console.log('online======', isOnline);
      if (!isOnline) {
        this.allInOneSnackBar(
          this.LangTextData.snackbarLabels.errorInternetConnection,
          '', 10000
        );
      }
    });
  }

  checkPostLoginDepartment(): void {
    const deptPopupOrigins = [
      'https://newstaging-prep.netlify.app',
      'https://stanford.prep.continualengine.com',
      'http://localhost:4200'
    ];
    if (deptPopupOrigins.includes(window.location.origin)) {
      this.platformuserService.fetchDeptPopupInfo().subscribe(
        (popupInfo) => {
          // popupInfo.org_enabled_to_check_dept = true;
          // popupInfo.requires_dept_info = true;
          if (popupInfo.org_enabled_to_check_dept && popupInfo.requires_dept_info) {
            const dialogRef = this.dialog.open(PostLoginDepartmentDialogComponent, {
              width: '500px',
              panelClass: 'rounded-dialog',
              backdropClass: 'dept-dialog-backdrop',
              disableClose: true,
            });
            dialogRef.afterClosed().subscribe(() => {
              this.navigateAfterLogin();
            });
          } else {
            this.navigateAfterLogin();
          }
        },
        () => {
          this.navigateAfterLogin();
        }
      );
    } else {
      this.navigateAfterLogin();
    }
  }

  // Redirects to the URL the user originally requested (set by AuthGuard)
  // if one exists, otherwise falls back to the dashboard.
  private navigateAfterLogin(): void {
    const redirectUrl = this.authRedirectService.consumeRedirectUrl();
    if (redirectUrl) {
      this.router.navigateByUrl(redirectUrl);
    } else {
      this.router.navigate(['dashboard']);
    }
  }

  // Password Toggle Visibility
  toggleVisibility(button: HTMLElement) {
    this.visible = !this.visible;
    this.inputType = this.visible ? 'text' : 'password';
    // this.cd.markForCheck();
    // Delay focusing button until after Angular updates the DOM
    setTimeout(() => {
      button.focus();
    });
  }

  focusMain(event: Event): void {
    event.preventDefault();
    const main = document.getElementById('main-content');
    if (main) {
      // Make it programmatically focusable
      main.setAttribute('tabindex', '-1');
      main.focus();
    }
  }

  // Accessibility: Focus on the email input field when the component initializes
  focusFirstInvalidControl(): void {
    setTimeout(() => {
      console.log(this.emailInputRef);

      if (this.emailInputRef?.nativeElement) {
        const inputEl = this.emailInputRef.nativeElement;

        // Ensure focusable
        inputEl.focus();
        inputEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        console.log('Focused email input');
      } else {
        console.warn('emailInputRef not found');
      }
    }, 300); // enough delay to let DOM settle
  }

  // ---------------------------------------------------------------
  // Check if a field is invalid and should show error state
  // Only valid if field is invalid AND touched
  // ---------------------------------------------------------------
  isFieldInvalid(fieldName: string): boolean {
    const field = this.UserLoginFormGroup.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }

  // ---------------------------------------------------------------
  // Check if a field is valid and should show success state
  // Only show if field is valid AND touched
  // ---------------------------------------------------------------
  isFieldValid(fieldName: string): boolean {
    const field = this.UserLoginFormGroup.get(fieldName);
    return !!(field && field.valid && (field.dirty || field.touched));
  }

  // ---------------------------------------------------------------
  // Dynamically build aria-describedby to include:
  // - Hint ID (always): for field instructions
  // - Error ID (only if invalid & touched): for error messages
  // This ensures screen readers only announce visible descriptions
  // and avoids redundant announcements
  // ---------------------------------------------------------------
  getDescribedById(fieldName: string): string {
    const ids: string[] = [];
    // Always include hint for field instructions
    ids.push(`${fieldName}-hint`);
    // Only include error if field is actually showing error message
    if (this.isFieldInvalid(fieldName)) {
      ids.push(`${fieldName}-error`);
    }
    return ids.join(' ');
  }

  // ---------------------------------------------------------------
  // Get contextual error message based on field validation errors
  // Provides actionable, concise suggestions per WCAG 3.3.3
  // ---------------------------------------------------------------
  getErrorMessage(fieldName: string): string {
    const control = this.UserLoginFormGroup.get(fieldName);
    if (!control) {
      return '';
    }
    switch (fieldName) {
      case 'username':
        if (control.hasError('required')) {
          return this.LangTextData?.htmlLabel.emailError;
        }
        if (control.hasError('pattern')) {
          return this.LangTextData?.htmlLabel.emailInvalidError;
        }
        return this.LangTextData?.htmlLabel.emailInvalid;
      case 'password':
        if (control.hasError('required')) {
          return this.LangTextData?.htmlLabel.passwordError;
        }
        if (control.hasError('minlength')) {
          const minLength = control.getError('minlength')?.requiredLength || 6;
          return this.LangTextData?.htmlLabel.passwordHint;
        }
        return this.LangTextData?.htmlLabel.passwordHint;
      default:
        return this.LangTextData?.htmlLabel.invalidField;
    }
  }

  // ---------------------------------------------------------------
  // Handle field blur for accessibility
  // Mark field as touched when user leaves the field
  // This ensures errors only show after user interaction
  // ---------------------------------------------------------------
  onFieldBlur(fieldName: string): void {
    const field = this.UserLoginFormGroup.get(fieldName);
    if (field) {
      field.markAsTouched();
      this.cd.markForCheck(); // Ensure change detection runs
    }
  }

  // ---------------------------------------------------------------
  // Get accessible label for password visibility toggle
  // Updates based on current visibility state
  // ---------------------------------------------------------------
  getPasswordToggleLabel(): string {
    return this.visible
      ? this.LangTextData?.ariaLabels?.passwordVisibilityToggle?.true || 'Hide password'
      : this.LangTextData?.ariaLabels?.passwordVisibilityToggle?.false || 'Show password';
  }

  // Accessibility Live Region
  announceMessage(message: string) {
    this.liveAnnouncer.clear(); // ensure previous message cleared
    setTimeout(() => {
      this.liveAnnouncer.announce(message, 'polite');
    }, 100); // small delay helps VoiceOver
  }

  // Snackbar with proper focus and accessibility
  allInOneSnackBar(
    message: string,
    action: string = 'OK',
    duration: number = 5000
  ) {
    // this.announceMessage(message);
    return this.snackbar.open(message, action, { duration });
  }
}
